import PropTypes from 'prop-types';

import ChartRowLayout from './ChartRowLayout';

const ChartRow = ({
  component,
  componentStyle = null,
  columnCount = '4',
  data = null,
  className = '',
  isHeader = false,
  isSticky = false,
  headers = '',
  activeColumnIdx = null,
  firstSelectableCell = null,
  setActiveColumn = null,
  chartType = null,
  percentage = false,
}) => {
  return (
    <ChartRowLayout
      componentType={component}
      componentStyle={componentStyle}
      columnCount={columnCount}
      data={data}
      className={className}
      isHeader={isHeader}
      isSticky={isSticky}
      headers={headers}
      activeColumnIdx={activeColumnIdx}
      firstSelectableCell={firstSelectableCell}
      setActiveColumn={setActiveColumn}
      chartType={chartType}
      percentage={percentage}
    />
  );
};

ChartRow.propTypes = {
  component: PropTypes.string.isRequired,
  componentStyle: PropTypes.string,
  columnCount: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape()),
  className: PropTypes.string,
  isHeader: PropTypes.bool,
  isSticky: PropTypes.bool,
  headers: PropTypes.string,
  activeColumnIdx: PropTypes.number,
  firstSelectableCell: PropTypes.number,
  setActiveColumn: PropTypes.func,
  chartType: PropTypes.string,
  percentage: PropTypes.bool,
};

export default ChartRow;
